
import DrawPoint from "../plot/DrawPoint"
import ConstantDraw from "../constants/ConstantDraw"
import { cartesian2lonlat } from "./utils/geojson"
import EditPointSpace from "./EditPointSpace"
class PointSpace extends DrawPoint {

    constructor(options) {
        super(options);
        this._style={
            heightReference: Cesium.HeightReference.NONE
        }
    }

    //左键
    leftClick(evt) {
        super.leftClick(evt);
        var lable = ConstantDraw.Style_Label;
        var pos = this.plot.position.getValue();
        var lonlat = cartesian2lonlat(pos);
        lable.text = `经度:${lonlat[0]}\n纬度:${lonlat[1]}\n高程:${lonlat[2]}`
        this.plot.label = lable;
        this.plot.extTag = "CL_Feature";
        this.plot.entitiesLabel= this.entitiesLabel;
        this.plot.entities= this.entities;
    }
    initEditor() {
        //初始化编辑器
        this.editHelp = new EditPointSpace(this.options); //初始化编辑类
    }

    // getCatesian3FromPX(px) {
    //     var position = viewer.scene.pickPosition(px);
    //     return position;
    // }
}

export default PointSpace